export default __webpack_public_path__ + "static/media/iconHomeProfileActive.5a274bab.svg";